import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

interface LedgerAccountDetails {
  id: string
  path: string
  total_balance: number
  parent: {
    id: string
    path: string
  } | null
}

interface UseGetLedgerAccountParams {
  id?: string
  cutoff?: string
}

export function useGetLedgerAccount ({ id, cutoff }: UseGetLedgerAccountParams) {
  return useQuery({
    queryKey: ['ledgerAccount', id, cutoff],
    queryFn: async () => {
      if (!id) return null

      const params = new URLSearchParams()
      if (cutoff) params.append('cutoff', cutoff)

      const response = await fetchWithHeaders(`/api/web/admin/ledger_accounts/${id}?${params}`)
      if (!response.ok) {
        throw new Error('Failed to fetch ledger account')
      }
      return response.json() as Promise<LedgerAccountDetails>
    },
    enabled: !!id,
  })
}
